<template>
  <b-link
    href="https://orbviz.com/"
    target="_blank"
    class="orbviz-logo"
  >
    <b-img
      fluid
      :src="OrbVizLogoHorizontal"
      alt="OrbViz logo"
    />
  </b-link>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import OrbVizLogoHorizontal from '@/assets/imgs/orbicaLogo/Orbviz Logo Horizontal.png'

@Component
export default class OrbVizLogo extends Vue {
  OrbVizLogoHorizontal = OrbVizLogoHorizontal
}

</script>

<style scoped>

.orbviz-logo img {
  height: auto;
  width: 5rem;
}

</style>
